import { PureComponent } from 'react'
import shortid from 'shortid'
import { BOARD_SIZE_2 as BOARD_SIZE, MAX_ENEMIES, PLAYER_HEALTH, SPEED_MOVE } from '../../config'

import BigGun from '../../assets/bigGun.svg'
import BigFire from '../../assets/bigFire.svg'
import BigFreeze from '../../assets/bigFreeze.svg'
import HealthBox from '../../assets/healthbox.svg'
import Bomb from '../../assets/bomb.png'
import BoxItem from '../../assets/box.png'

import { levels } from '../../config/levels2.config'

import { boxesList } from '../../gamesettings/boxes'
import { BoardState, Box, Gun, KeyVar } from '../../types'
import { boxesConfig } from '../../config/boxes.config'

import { zoneColors } from '../../config/zone.config'
import Column from './Column/Column'
import { gunCharacteristics, moveList } from '../../config/player.config'
import './Board.scss'

function getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
}

const initialState: BoardState = {
    bombs: 0,
    gameStatus: 'paused',
    winner: false,
    gunShotCounter: 0,
    fireShotCounter: 0,
    freezeShotCounter: 0,
    lastMove: KeyVar.w,
    player: {
        health: PLAYER_HEALTH,
        posX: 10,
        posY: 10
    },
    healthBoxes: 0,
    seconds: 0,
    gun: Gun.gun,
    openFire: false,
    keyActive: {
        w: false,
        a: false,
        s: false,
        d: false,
    },
    enemies: [],
    boxes: [],
    isGameOver: false,
}

class Board extends PureComponent<{}, BoardState> {

    state: BoardState = { ...initialState }

    moveInterval: any = null
    fireInterval: any = null
    moveEnemyInterval: any = null

    nextShotGun: number = new Date().getTime() / 1000
    nextShotFire: number = new Date().getTime() / 1000
    nextShotFreeze: number = new Date().getTime() / 1000

    calcDangerZone = () => {
        let zone = 0
        if (this.state.seconds > 325) zone = 1
        if (this.state.seconds > 326) zone = 2
        if (this.state.seconds > 327) zone = 3

        if (this.state.seconds > 415) zone = 4
        if (this.state.seconds > 416) zone = 5
        if (this.state.seconds > 417) zone = 6
        if (this.state.seconds > 418) zone = 7
        if (this.state.seconds > 419) zone = 8
        if (this.state.seconds > 420) zone = 9

        if (this.state.seconds > 500) zone = 10
        if (this.state.seconds > 501) zone = 11
        if (this.state.seconds > 502) zone = 12
        if (this.state.seconds > 503) zone = 13
        if (this.state.seconds > 504) zone = 14
        if (this.state.seconds > 505) zone = 15
        
        if (this.state.seconds > 530) zone = 16
        if (this.state.seconds > 531) zone = 17
        if (this.state.seconds > 532) zone = 18
        if (this.state.seconds > 533) zone = 19
        if (this.state.seconds > 534) zone = 20
        return zone
    }

    explode = () => {
        if (this.state.bombs <= 0) return

        const playerPositionX: number = this.state.player.posX
        const playerPositionY: number = this.state.player.posY

        const calcHealth: number = this.state.player.health - 1000

        this.setState({
            bombs: this.state.bombs - 1,
            player: {
                ...this.state.player,
                health: calcHealth
            },
            enemies: this.state.enemies.filter(enemy => {

                const inZoneByX: boolean = enemy.posX > playerPositionX - 8 && enemy.posX < playerPositionX + 8 
                const inZoneByY: boolean = enemy.posY > playerPositionY - 8 && enemy.posY < playerPositionY + 8 
            
                const shouldBeDestroyed: boolean = inZoneByX && inZoneByY
                return !shouldBeDestroyed
            })
        })
        
        if (calcHealth <= 0) {
            clearInterval(this.moveInterval)
            clearInterval(this.fireInterval)
            clearInterval(this.moveEnemyInterval)

            this.setState({
                player: {
                    ...this.state.player,
                    health: 0,
                },
                seconds: 0,
                gameStatus: 'paused',
                isGameOver: true
            })
        }
    }

    shot = () => {
        let calculateZones: [number, number][] = []
        if (this.state.lastMove === 'w') {
            calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX - (index + 1), this.state.player.posY])
        }
        if (this.state.lastMove === 'a') {
            calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX, this.state.player.posY - (index + 1)])
        }
        if (this.state.lastMove === 's') {
            calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX + (index + 1), this.state.player.posY])
        }
        if (this.state.lastMove === 'd') {
            calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX, this.state.player.posY + (index + 1)])
        }

        if (this.state.gun === 'gun') {
            if (this.state.gunShotCounter <= 0) return
            this.nextShotGun = (new Date().getTime() / 1000) + (gunCharacteristics.gun.interval / 1000)
            this.setState({
                gunShotCounter: this.state.gunShotCounter - 1
            })
        }

        if (this.state.gun === 'freeze') {
            if (this.state.freezeShotCounter <= 0) return
            this.nextShotFreeze = (new Date().getTime() / 1000) + (gunCharacteristics.freeze.interval / 1000)
            this.setState({
                freezeShotCounter: this.state.freezeShotCounter - 1
            })
        }

        if (this.state.gun === 'fire') {
            if (this.state.fireShotCounter <= 0) return
            this.nextShotFire = (new Date().getTime() / 1000) + (gunCharacteristics.fire.interval / 1000)
            this.setState({
                fireShotCounter: this.state.fireShotCounter - 1
            })
        }

        if (this.state.gun === 'fire' || this.state.gun === 'freeze') {
            this.setState({
                enemies: this.state.enemies.map(item => {
                    const findPosition = calculateZones.find(zone => zone[0] === item.posX && zone[1] === item.posY)
                    if (findPosition) {
                        item.health = item.health - gunCharacteristics[this.state.gun].shot
                        if (this.state.gun === 'freeze') item.freeze = 7
                    }
                    return item
                }).filter(en => en.health > 0)
            })
        }

        if (this.state.gun === 'gun') {
            const enemiesToHit = this.state.enemies.filter(item => {
                const findPosition = calculateZones.find(zone => zone[0] === item.posX && zone[1] === item.posY)
                return !!findPosition
            })

            if (this.state.lastMove === 's' && enemiesToHit.length) {
                const numbersList = enemiesToHit.map(item => item.posX)
                const findEnemy = enemiesToHit.find(item => item.posX === Math.min(...numbersList))

                this.setState({
                    enemies: this.state.enemies.map(item => {
                        if (item.id === findEnemy?.id) {
                            item.health = item.health - gunCharacteristics[this.state.gun].shot
                        }
                        return item
                    }).filter(en => en.health > 0)
                })
            }

            if (this.state.lastMove === 'w' && enemiesToHit.length) {
                const numbersList = enemiesToHit.map(item => item.posX)
                const findEnemy = enemiesToHit.find(item => item.posX === Math.max(...numbersList))

                this.setState({
                    enemies: this.state.enemies.map(item => {
                        if (item.id === findEnemy?.id) {
                            item.health = item.health - gunCharacteristics[this.state.gun].shot
                        }
                        return item
                    }).filter(en => en.health > 0)
                })
            }

            if (this.state.lastMove === 'a' && enemiesToHit.length) {
                const numbersList = enemiesToHit.map(item => item.posY)
                const findEnemy = enemiesToHit.find(item => item.posY === Math.max(...numbersList))

                this.setState({
                    enemies: this.state.enemies.map(item => {
                        if (item.id === findEnemy?.id) {
                            item.health = item.health - gunCharacteristics[this.state.gun].shot
                        }
                        return item
                    }).filter(en => en.health > 0)
                })
            }

            if (this.state.lastMove === 'd' && enemiesToHit.length) {
                const numbersList = enemiesToHit.map(item => item.posY)
                const findEnemy = enemiesToHit.find(item => item.posY === Math.min(...numbersList))

                this.setState({
                    enemies: this.state.enemies.map(item => {
                        if (item.id === findEnemy?.id) {
                            item.health = item.health - gunCharacteristics[this.state.gun].shot
                        }
                        return item
                    }).filter(en => en.health > 0)
                })
            }
        }
    }

    openFire = () => {
        let time = 0
        if (this.state.gun === 'gun') time = this.nextShotGun
        if (this.state.gun === 'fire') time = this.nextShotFire
        if (this.state.gun === 'freeze') time = this.nextShotFreeze

        if ((new Date().getTime() / 1000) > time) {
            this.setState({
                openFire: true
            })

            this.shot()
            this.fireInterval = setInterval(() => {
                this.shot()
            }, gunCharacteristics[this.state.gun].interval)
        }
    }

    stopFire() {
        this.setState({
            openFire: false
        })

        clearInterval(this.fireInterval)
    }

    registerLastMove = (key: keyof typeof KeyVar) => {
        this.setState({
            lastMove: key
        })
    }

    generateBox = (type: Box) => {
        this.setState({
            boxes: [
                ...this.state.boxes,
                {
                    id: shortid.generate(),
                    posX: getRandomInt(BOARD_SIZE - 1),
                    posY: getRandomInt(BOARD_SIZE - 1),
                    type
                }
            ]
        })
    }

    movePlayer = (x: number, y: number) => () => {
        let newPosX: number = this.state.player.posX + x
        let newPosY: number = this.state.player.posY + y

        if (newPosX >= 0 && newPosX < BOARD_SIZE && newPosY >= 0 && newPosY < BOARD_SIZE) {
            const findEnemies = this.state.enemies.find(el => el.posX === newPosX && newPosY === el.posY)

            if (!findEnemies) {
                this.openBoxes(newPosX, newPosY)

                this.setState({
                    player: {
                        ...this.state.player,
                        posX: newPosX,
                        posY: newPosY
                    }
                })
            }
        }
    }

    openBoxes = (x: number, y: number) => {
        const findBoxes = this.state.boxes.filter(box => box.posX === x && box.posY === y)

        let addFire = 0
        let addFreeze = 0
        let addGun = 0
        let addHealthBoxes = 0
        let addBombs = 0

        if (findBoxes.length) {
            findBoxes.forEach((el) => {
                addFire = addFire + boxesConfig[el.type].fireCartridges
                addFreeze = addFreeze + boxesConfig[el.type].freezeCartridges
                addGun = addGun + boxesConfig[el.type].gunCartridges
                addHealthBoxes = addHealthBoxes + boxesConfig[el.type].healthBoxes
                addBombs = addBombs + boxesConfig[el.type].bomb
            })
        }

        this.setState({
            fireShotCounter: this.state.fireShotCounter + addFire,
            freezeShotCounter: this.state.freezeShotCounter + addFreeze,
            gunShotCounter: this.state.gunShotCounter + addGun,
            healthBoxes: this.state.healthBoxes + addHealthBoxes,
            bombs: this.state.bombs + addBombs,
            boxes: this.state.boxes.filter(item => !findBoxes.map(item => item.id).includes(item.id)),
        })
    }

    startMove = (key: keyof typeof KeyVar) => {
        if (this.moveInterval) clearInterval(this.moveInterval)

        const movePlayerToNewPosition = this.movePlayer(moveList[key].x, moveList[key].y)

        this.registerLastMove(key)
        movePlayerToNewPosition()
        this.moveInterval = setInterval(movePlayerToNewPosition, SPEED_MOVE)
    }

    stopMove = () => {
        clearInterval(this.moveInterval)
    }

    activateKey = (key: keyof typeof KeyVar) => {
        if (this.state.keyActive[key] !== true) {
            this.startMove(key)
            this.setState({
                keyActive: {
                    ...{
                        w: false,
                        a: false,
                        s: false,
                        d: false
                    },
                    [key]: true,
                }
            })
        }
    }

    startGame = () => {
        let gameLevels: any = levels
        const itemsToAdd = gameLevels[`${this.state.seconds}`] ? gameLevels[`${this.state.seconds}`].map((el: any) => ({ ...el, id: shortid.generate() })) : []

        let enemiesBehindPlayerCount = 0

        if (Object.keys(boxesList).includes(`${this.state.seconds}`)) {
            const list: any = boxesList
            this.generateBox(list[`${this.state.seconds}`])
        }

        this.setState({
            enemies: [
                ...itemsToAdd,
                ...this.state.enemies.map(item => {
                    const { player: { posX, posY } } = this.state

                    const positionsBehindPlayer = [
                        [posX + 1, posY - 1],
                        [posX + 1, posY],
                        [posX + 1, posY + 1],
                        [posX - 1, posY - 1],
                        [posX - 1, posY],
                        [posX - 1, posY + 1],
                        [posX, posY - 1],
                        [posX, posY + 1],
                    ].filter(item => item[0] >= 0)
                        .filter(item => item[0] <= BOARD_SIZE - 1)
                        .filter(item => item[1] >= 0)
                        .filter(item => item[1] <= BOARD_SIZE - 1)

                    const isEnemyBehindPlayer = positionsBehindPlayer.find(el => el[0] === item.posX && el[1] === item.posY)

                    if (isEnemyBehindPlayer) {
                        enemiesBehindPlayerCount = enemiesBehindPlayerCount + 1
                        return item
                    }

                    if (item.freeze === 0) {
                        let newPosX = item.posX
                        let newPosY = item.posY

                        if (posX > newPosX) item.posX = item.posX + 1
                        if (posX < newPosX) item.posX = item.posX - 1

                        if (posY > newPosY) item.posY = item.posY + 1
                        if (posY < newPosY) item.posY = item.posY - 1
                    } else {
                        item.freeze = item.freeze - 1
                    }

                    return item
                }).filter(item => item.health > 0),
            ]
        })

        let newPlayerHealth = this.state.player.health - enemiesBehindPlayerCount * 100

        const zone = this.calcDangerZone()

        if (this.state.player.posX < zone || this.state.player.posX >= BOARD_SIZE - zone ||
            this.state.player.posY < zone || this.state.player.posY >= BOARD_SIZE - zone) newPlayerHealth = newPlayerHealth - 70

        if (newPlayerHealth < 0 || this.state.enemies.length > MAX_ENEMIES) newPlayerHealth = 0

        this.setState({
            seconds: this.state.seconds + 1,
            player: {
                ...this.state.player,
                health: newPlayerHealth,
            }
        })

        if (newPlayerHealth === 0) {
            clearInterval(this.moveInterval)
            clearInterval(this.fireInterval)
            clearInterval(this.moveEnemyInterval)

            this.setState({
                seconds: 0,
                gameStatus: 'paused',
                isGameOver: true
            })
        }

        if (this.state.seconds > 629 && this.state.enemies.length === 0) {
            this.win()
        }
    }

    componentDidMount(): void {

        document.addEventListener('keydown', (e) => {
            if (!this.state.isGameOver && this.state.gameStatus === 'active') {
                if (e.code === 'KeyW') this.activateKey('w')
                if (e.code === 'KeyA') this.activateKey('a')
                if (e.code === 'KeyS') this.activateKey('s')
                if (e.code === 'KeyD') this.activateKey('d')

                if (e.code === 'Digit1' || e.code === 'Digit2' || e.code === 'Digit3') this.stopFire()
                if (e.code === 'Digit1') this.setState({ gun: 'gun' })
                if (e.code === 'Digit2') this.setState({ gun: 'fire' })
                if (e.code === 'Digit3') this.setState({ gun: 'freeze' })
                if (e.code === 'Digit4' && !!this.state.healthBoxes && this.state.player.health !== PLAYER_HEALTH) {
                    this.setState({ player: { ...this.state.player, health: PLAYER_HEALTH }, healthBoxes: this.state.healthBoxes - 1 })
                }
                if (e.code === 'Digit5') this.explode()
                if (e.code === 'KeyK' && !this.state.openFire) this.openFire()
            }
        })

        document.addEventListener('keyup', (e) => {
            if (!this.state.isGameOver && this.state.gameStatus === 'active') {
                if (e.code === 'KeyW' || e.code === 'KeyA' || e.code === 'KeyS' || e.code === 'KeyD') {
                    this.stopMove()
                    this.setState({
                        keyActive: {
                            w: false,
                            a: false,
                            s: false,
                            d: false
                        }
                    })
                }

                if (e.code === 'KeyK') this.stopFire()
            }
        })
    }

    calcTime = (sec: number) => {
        if (sec < 60) {
            return `00:${sec < 10 ? '0' : ''}${sec}`
        } else {
            let minutes = Math.floor(sec / 60)
            let seconds = sec % 60
            return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
        }
    }

    stopGame = () => {
        clearInterval(this.moveEnemyInterval)
        clearInterval(this.moveInterval)
        clearInterval(this.fireInterval)
        clearInterval(this.moveEnemyInterval)
        this.stopFire()

        this.setState({
            ...initialState
        })
    }

    win = () => {
        clearInterval(this.moveEnemyInterval)
        clearInterval(this.moveInterval)
        clearInterval(this.fireInterval)
        clearInterval(this.moveEnemyInterval)
        this.stopFire()

        this.setState({
            ...initialState,
            winner: true
        })
    }

    render() {

        const { player: { posX, posY } } = this.state

        let calculateZones: [number, number][] = []

        let isAvailable = false

        if (this.state.gun === 'gun' && this.state.gunShotCounter !== 0) isAvailable = true
        if (this.state.gun === 'fire' && this.state.fireShotCounter !== 0) isAvailable = true
        if (this.state.gun === 'freeze' && this.state.freezeShotCounter !== 0) isAvailable = true

        if (this.state.openFire && isAvailable) {
            if (this.state.lastMove === 'w') {
                calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX - (index + 1), this.state.player.posY])
            }
            if (this.state.lastMove === 'a') {
                calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX, this.state.player.posY - (index + 1)])
            }
            if (this.state.lastMove === 's') {
                calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX + (index + 1), this.state.player.posY])
            }
            if (this.state.lastMove === 'd') {
                calculateZones = Array(gunCharacteristics[this.state.gun].distance).fill(null).map((el, index) => [this.state.player.posX, this.state.player.posY + (index + 1)])
            }
        }

        const getZone = this.calcDangerZone()

        return (
            <div className='container'>
                <div className='board'>
                    {Array(BOARD_SIZE).fill(null).map((item, index) => (
                        <div className='row' key={index}>
                            {Array(BOARD_SIZE).fill(null).map((item, i) => {
                                const findEnemies = this.state.enemies.filter(en => en.posX === index && en.posY === i)
                                const findFreezed = !!findEnemies.filter(en => en.freeze).length
                                const enemiesHelath = findEnemies.map(el => el.health).reduce((prev, next) => prev + next, 0)

                                const hasBoxes = !!this.state.boxes.find(item => item.posX === index && item.posY === i)
                                const hasBomb = this.state.boxes.find(item => item.posX === index && item.posY === i)?.type === Box.level9
                                const isDanger = index < getZone || index >= BOARD_SIZE - getZone || i < getZone || i >= BOARD_SIZE - getZone
                                const gunClassName = calculateZones.find(el => el[0] === index && el[1] === i) ? zoneColors[this.state.gun] : ''
                                return (
                                    <Column
                                        hasBomb={hasBomb}
                                        findFreezed={findFreezed}
                                        gun={this.state.gun}
                                        lastMove={this.state.lastMove}
                                        enemiesCount={findEnemies.length}
                                        enemiesHealth={enemiesHelath}
                                        index={index}
                                        i={i}
                                        posX={posX}
                                        posY={posY}
                                        hasBoxes={hasBoxes}
                                        calculateZones={calculateZones}
                                        isDanger={isDanger}
                                        gunClassName={gunClassName}
                                        playerHealth={this.state.player.health}
                                        key={i}
                                    />
                                )
                            })}
                        </div>
                    ))}
                </div>
                <div className='panel'>
                    <div className='panelTime'>Time: {this.calcTime(this.state.seconds)}</div>
                    <div className='panelControl'>
                        {this.state.gameStatus === 'paused' && (
                            <button type='button' className='panelControlButton' onClick={() => {
                                this.moveEnemyInterval = setInterval(this.startGame, 1000)
                                if (this.state.seconds === 0) {
                                    this.setState({
                                        ...initialState,
                                        gameStatus: 'active',
                                        isGameOver: false,
                                        winner: false
                                    })
                                } else {
                                    this.setState({
                                        gameStatus: 'active',
                                        isGameOver: false,
                                        winner: false
                                    })
                                }
                            }}>{this.state.seconds === 0 ? 'Start' : 'Resume'}</button>)}
                        {this.state.gameStatus === 'active' && (
                            <button type='button' className='panelControlButton' onClick={() => {
                                clearInterval(this.moveEnemyInterval)
                                this.stopMove()
                                this.setState({
                                    keyActive: {
                                        w: false,
                                        a: false,
                                        s: false,
                                        d: false
                                    },
                                    openFire: false,
                                    gameStatus: 'paused',
                                    winner: false
                                })
                                this.stopFire()
                            }}>Pause</button>)}
                        <button type='button' className='panelControlButton restart' onClick={this.stopGame}>Stop</button>
                    </div>
                    <div className='panelGuns'>
                        <div className='container'>
                            <div className={`title ${this.state.gun === 'gun' && 'active'}`}>1</div>
                            <div className={`gun ${!!this.state.gunShotCounter && 'active'}`}><img src={BigGun} alt='' /></div>
                            <div className={`counter ${!!this.state.gunShotCounter && 'active'}`}>{this.state.gunShotCounter}</div>
                        </div>
                        <div className='container'>
                            <div className={`title ${this.state.gun === 'fire' && 'active'}`}>2</div>
                            <div className={`gun ${!!this.state.fireShotCounter && 'active'}`}><img src={BigFire} alt='' /></div>
                            <div className={`counter ${!!this.state.fireShotCounter && 'active'}`}>{this.state.fireShotCounter}</div>
                        </div>
                        <div className='container'>
                            <div className={`title ${this.state.gun === 'freeze' && 'active'}`}>3</div>
                            <div className={`gun ${!!this.state.freezeShotCounter && 'active'}`}><img src={BigFreeze} alt='' /></div>
                            <div className={`counter ${!!this.state.freezeShotCounter && 'active'}`}>{this.state.freezeShotCounter}</div>
                        </div>
                        <div className='container'>
                            <div className={`title`}>4</div>
                            <div className={`gun ${!!this.state.healthBoxes && 'active'}`}><img src={HealthBox} alt='' /></div>
                            <div className={`counter ${!!this.state.healthBoxes && 'active'}`}>{this.state.healthBoxes}</div>
                        </div>
                        <div className='container'>
                            <div className={`title`}>5</div>
                            <div className={`gun ${!!this.state.bombs && 'active'}`}><img src={Bomb} alt='' /></div>
                            <div className={`counter ${!!this.state.bombs && 'active'}`}>{this.state.bombs}</div>
                        </div>
                    </div>
                    <div className='panelText' style={{ width: '400px' }}>{`The number of enemies on the map must not exceed `}{MAX_ENEMIES}!</div>
                    <div className='panelText'>{`Enemies on map now: `}
                        <b>{this.state.enemies.length}</b>{` (${MAX_ENEMIES - this.state.enemies.length})`}
                    </div>
                    <div className='panelText'>Use <b>1, 2, 3, 4, 5</b> to change gun and use health boxes and bombs.</div>
                    <div className='panelText'>Use <b>W, A, S, D</b> to move your tank.</div>
                    <div className='panelText'>Press or hold <b>K</b> to open fire.</div>
                    <div className='panelText'>Collect <img src={BoxItem} style={{ width: '20px' }} alt='' /> to replenish ammo.</div>
                    <div className='panelText'>
                        <a href='https://www.youtube.com/watch?v=ZdqG6SE_fgc' style={{ color: 'lightblue' }}>How to play this game (click here)</a>
                    </div>
                    <div className='panelText'></div>
                    <div className='panelButtons'>
                        <div className='panelButtonsList'>
                            <div className='item'></div>
                            <div className={`item filled ${this.state.keyActive.w && 'active'}`}>W</div>
                            <div className='item'></div>
                            <div className='item'></div>
                            <div className='item'></div>
                            <div className='item'></div>
                            <div className={`item filled ${this.state.keyActive.a && 'active'}`}>A</div>
                            <div className={`item filled ${this.state.keyActive.s && 'active'}`}>S</div>
                            <div className={`item filled ${this.state.keyActive.d && 'active'}`}>D</div>
                            <div className='item'></div>
                            <div className='item'></div>
                            <div className={`item filled ${this.state.openFire && 'active'}`}>K</div>
                        </div>
                    </div>
                    {this.state.winner && (
                        <div className='panelWin'>You win!</div>
                    )}
                    {this.state.isGameOver && (
                        <div className='panelGameOver'>Game over!</div>
                    )}
                </div>
            </div>
        )
    }
}

export default Board